module.exports = __webpack_public_path__ + "static/img/lx.fbf7c6d4.png";